type SubscriptionLike = {
  type?: string;
  isActive?: boolean;
  endDate?: string | Date | null;
} | null | undefined;

type UserLike = {
  role?: string;
  premiumPlan?: string;
  isPremium?: boolean;
  createdAt?: string | Date | null;
  studioTrial?: {
    isActive?: boolean;
    endsAt?: string | Date | null;
    trialEndsAt?: string | Date | null;
  };
  subscription?: SubscriptionLike;
} | null | undefined;

const hasActiveStudioTrial = (user: UserLike): boolean => {
  if (user?.studioTrial?.isActive === true) return true;

  const trialEndsAt = user?.studioTrial?.endsAt || user?.studioTrial?.trialEndsAt;
  if (trialEndsAt) {
    const endTime = new Date(trialEndsAt).getTime();
    return !Number.isNaN(endTime) && endTime >= Date.now();
  }

  if (!user?.createdAt) return false;
  const createdAt = new Date(user.createdAt).getTime();
  return !Number.isNaN(createdAt) && createdAt + 3 * 24 * 60 * 60 * 1000 >= Date.now();
};

export const hasPremiumSubscription = (user: UserLike): boolean => {
  if (user?.role === 'admin' || user?.premiumPlan === 'ADMIN') return true;
  if (hasActiveStudioTrial(user)) return true;
  if (user?.isPremium === true) return true;

  const subscription = user?.subscription;
  if (subscription && subscription.type && subscription.type !== 'free') {
    const endTime = subscription.endDate ? new Date(subscription.endDate).getTime() : NaN;
    const subscriptionActive = subscription.isActive !== false
      && (!subscription.endDate || Number.isNaN(endTime) || endTime >= Date.now());
    if (subscriptionActive) return true;
  }

  return false;
};

export const hasPaidPlan = (user: UserLike): boolean => {
  if (user?.role === 'admin' || user?.premiumPlan === 'ADMIN') return true;
  if (user?.isPremium === true) return true;

  const subscription = user?.subscription;
  if (subscription && subscription.type && subscription.type !== 'free') {
    const endTime = subscription.endDate ? new Date(subscription.endDate).getTime() : NaN;
    const subscriptionActive = subscription.isActive !== false
      && (!subscription.endDate || Number.isNaN(endTime) || endTime >= Date.now());
    if (subscriptionActive) return true;
  }

  return false;
};

export const canSaveWithPlan = hasPaidPlan;

export const hasAdvancedToolsAccess = (user: UserLike): boolean => hasPremiumSubscription(user);
